import { useEffect, useRef } from 'react';

const AutoScroll = ({ containerRef, dwellInSeconds = 12 }) => {
  const timerRef = useRef(null);

  useEffect(() => {
    const advance = () => {
      const container = containerRef.current;
      if (!container) return;

      const maxScroll = container.scrollWidth - container.clientWidth;
      if (maxScroll <= 1) return;

      if (container.scrollLeft >= maxScroll - 1) {
        container.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }

      const containerLeft = container.getBoundingClientRect().left;
      const next = Array.from(container.children).find(
        (child) => child.getBoundingClientRect().left - containerLeft > 1
      );
      const delta = next ? next.getBoundingClientRect().left - containerLeft : 0;
      const target = next ? Math.min(container.scrollLeft + delta, maxScroll) : maxScroll;

      container.scrollTo({ left: target, behavior: 'smooth' });
    };

    timerRef.current = setInterval(advance, dwellInSeconds * 1000);

    return () => clearInterval(timerRef.current);
  }, [containerRef, dwellInSeconds]);

  return null;
};

export default AutoScroll;
